module.exports = __webpack_public_path__ + "static/media/broadwayLunch.8aadc637.pdf";